import { DisableAdblockDialogContainer } from './DisableAdblockDialogContainer.tsx';
import { mountDialogUIReactComponent } from '../../ui_platform/mountDialogUIReactComponent.tsx';
const renderDisableAdblockDialog = mountDialogUIReactComponent(DisableAdblockDialogContainer);
export function showDisableAdblockDialog(options) {
    renderDisableAdblockDialog({
        continuationAction: options.continuationAction,
        variant: options.variant
    });
}
